import type { ReduxState } from '@spa/redux/ReduxState'

import type { RestModalState } from '../modules/main'

export const getSubmitResults = (state: ReduxState): RestModalState['submit'] =>
  state.restModal.submit

export const getCurrentStep = (
  state: ReduxState
): RestModalState['currentStep'] => state.restModal.currentStep
